import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    arrNotEmpty (value) {
      return Array.isArray(value) && value.length > 0
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
